/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthPlatformLoginInput } from "../../entities/models/AuthPlatformLoginInput";
import { z } from "zod/v4";

export const modelsAuthPlatformLoginInputSchema = z.object({
    "login": z.string(),
"password": z.string()
    }) as unknown as z.ZodType<ModelsAuthPlatformLoginInput>